module.exports = __webpack_public_path__ + "76477818f3fd52b1e5bbefd723253a74.svg";